const initVal = null;

const JobsUrl = (state = initVal, action) => {
  switch (action.type) {
    case "SETJOBSURL":
      return action.payload;
    default:
      return state;
  }
}

export default JobsUrl;
